import { Progress } from "@chakra-ui/react";

export const LinearProgress = () => {
  return (
    <Progress.Root value={null}>
      <Progress.Track>
        <Progress.Range />
      </Progress.Track>
    </Progress.Root>
  );
};
